import FormInput from './FormInput'

export default FormInput
// eslint-disable-next-line import/export
export * from './FormInput'
